import React from "react";
import { useParams } from "react-router-dom";
import Checkoutform from "../endOfSummer/form";

export default function EventPage(appProps) {
  const { eventKey } = useParams();
  return <Checkoutform {...appProps} eventKey={eventKey} />;
}
